<!-- this is a mobile only page. -->
<template>
    <div class="app-sliders-view">
        <return-back-menu v-bind="ReturnMenuSettings"/>
        <section class="app-carousels-mobile  ">
            <div class="portfolio-item-title"><h2 class="--tert">{{ this.SliderDetails.Title }}</h2></div>
            <div class="portfolio-item-mobile  ">
                <div class="portfolio-item-container">
                    <div class="portfolio-item ">
                        <hooper
                            ref="slider"
                            style="height: 812px; width:375px;"
                            :auto-play="true"
                            :play-speed="4000"
                        >
                            <template v-for="val in ShowSlideList">
                                <slide v-for="item in val.Items" :key="item.id">
                                    <img
                                    :src="
                                        require('../' +
                                        'assets/imgs/our-apps-screens' +
                                        '/' +
                                        item.image)
                                    "
                                    class="slider-item"
                                    alt=""
                                    />
                                </slide>
                            </template>
                            <hooper-navigation slot="hooper-addons"></hooper-navigation>
                        </hooper>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import ReturnBackMenu from '@/components/ui/ReturnBackMenu'
import { Hooper, Slide, Navigation as HooperNavigation } from 'hooper'
//import SocialIconsMobile from '@/components/ui/SocialIconsMobile'

export default {
    components: { 
        Hooper,
        Slide,
        HooperNavigation,
        ReturnBackMenu//,
        //SocialIconsMobile
    },
     data(){
        return {
            SocialIconsMobileSettings:{
                DarkIconsTrue:false,
            },            
            ReturnMenuSettings:{
                colorTheme:true
            },
            SliderDetails:{
                Title: 'STEPP ASSIST',
            },
            ShowSlideList: [{
                Id: 1,
                Title: 'Stepp',
                Items: [
                    {
                    id: 0,
                    image: 'stepp-assist/1-stepp-assist-walkthrough.jpg',
                    title: 'Stepp Assist',
                    active: true,
                    sortOrder: 1
                    },
                    {
                    id: 1,
                    image: 'stepp-assist/2-stepp-assist-menu.jpg',
                    title: 'Stepp Assist',
                    active: true,
                    sortOrder: 2
                    },
                    {
                    id: 2,
                    image: 'stepp-assist/3-stepp-assist-home.jpg',
                    title: 'Stepp Assist',
                    active: true,
                    sortOrder: 3
                    },
                    {
                    id: 3,
                    image: 'stepp-assist/4-stepp-assist-chat.jpg',
                    title: 'Stepp Assist',
                    active: true,
                    sortOrder: 4
                    },
                    {
                    id: 4,
                    image: 'stepp-assist/5-stepp-assist-emergency-assist.jpg',
                    title: 'Stepp Assist',
                    active: true,
                    sortOrder: 5
                    },
                    {
                    id: 5,
                    image: 'stepp-assist/6-stepp-assist-personal.jpg',
                    title: 'Stepp Assist',
                    active: true,
                    sortOrder: 6
                    }
                ]
            }]
        }
    } 
}
</script>

<style>

</style>
